import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {FaIcon} from "../../../FaIcon";
import {TYPE_ADGROUP, TYPE_BUSINESS_UNIT, TYPE_CAMPAIGNS_CONFIGURATION} from "../DashboardRow";

class PlatformBudgetCellClass extends Component {
    formatMoney(amount, currency) {
        const safeCurrency = currency || 'USD';
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: safeCurrency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(amount || 0);
        } catch (e) {
            return `${(amount || 0).toFixed(0)} ${safeCurrency}`;
        }
    }

    renderAdgroupWithCampaignLevelBudget() {
        const {t} = this.props;
        return (
            <td className="single-data">
                <div className="info-icon-container">
                    <span className="platform-budget-dash">—</span>
                    <div className="warning-tooltip">
                        <div className="warning-tooltip-body">
                            <p className="warning-tooltip-text">
                                {t('dashboard.platform_budget.adgroup_at_campaign_level_tooltip')}
                            </p>
                        </div>
                    </div>
                </div>
            </td>
        );
    }

    renderEmpty() {
        const {t} = this.props;
        return (
            <td className="single-data">
                <div className="info-icon-container">
                    <FaIcon iconName="info-circle"/>
                    <div className="warning-tooltip">
                        <div className="warning-tooltip-body">
                            <p className="warning-tooltip-text">
                                {t('dashboard.platform_budget.empty_tooltip')}
                            </p>
                        </div>
                    </div>
                </div>
            </td>
        );
    }

    renderBreakdownTooltip() {
        const {platformBudget, t} = this.props;
        if (!platformBudget) return null;

        const currency = (platformBudget.currencies && platformBudget.currencies[0]) || platformBudget.currency;
        const suffix = t('dashboard.platform_budget.daily_suffix');
        const items = [];

        const isAggregate = platformBudget.daily_from_daily_budgets !== undefined;
        if (isAggregate) {
            const hasDaily = platformBudget.daily_from_daily_budgets > 0;
            const hasLifetime = platformBudget.daily_from_lifetime > 0;
            const hasBothParts = hasDaily && hasLifetime;

            if (hasDaily) {
                items.push(
                    <li key="daily">
                        {hasBothParts && <span className="tooltip-sum-op"></span>}
                        {t('dashboard.platform_budget.breakdown_daily')}: {this.formatMoney(platformBudget.daily_from_daily_budgets, currency)}{suffix}
                    </li>
                );
            }
            if (hasLifetime) {
                items.push(
                    <li key="lifetime">
                        {hasBothParts && <span className="tooltip-sum-op">+ </span>}
                        {t('dashboard.platform_budget.breakdown_lifetime_as_daily')}: {this.formatMoney(platformBudget.daily_from_lifetime, currency)}{suffix}
                        {platformBudget.lifetime_total ? ` · ${this.formatMoney(platformBudget.lifetime_total, currency)} total` : ''}
                    </li>
                );
            }
            if (hasBothParts) {
                items.push(
                    <li key="total" className="tooltip-total">
                        = {t('dashboard.platform_budget.breakdown_total')}: {this.formatMoney(platformBudget.daily_equivalent, currency)}{suffix}
                    </li>
                );
            }
            items.push(
                <li key="count" className="tooltip-subtle">
                    {t('dashboard.platform_budget.breakdown_campaigns_count', {count: platformBudget.campaigns_with_budget, total: platformBudget.campaigns_total})}
                </li>
            );
            if (platformBudget.currencies && platformBudget.currencies.length > 1) {
                items.push(
                    <li key="mix" className="warning">
                        ⚠ {t('dashboard.platform_budget.mixed_currencies_warning')}
                    </li>
                );
            }
        } else if (platformBudget.has_lifetime) {
            items.push(
                <li key="lifetime">
                    {t('dashboard.platform_budget.breakdown_lifetime_as_daily')}
                    {platformBudget.lifetime_amount ? `: ${this.formatMoney(platformBudget.lifetime_amount, currency)} total` : ''}
                    {platformBudget.from_date && platformBudget.to_date ? ` (${platformBudget.from_date} → ${platformBudget.to_date})` : ''}
                </li>
            );
        }

        if (items.length === 0) return null;

        return (
            <div className="warning-tooltip">
                <div className="warning-tooltip-body">
                    <ul className="warning-tooltip-list">{items}</ul>
                </div>
            </div>
        );
    }

    render() {
        const {platformBudget, rowType, t} = this.props;

        if (platformBudget === null || platformBudget === undefined) {
            if (rowType === TYPE_ADGROUP) {
                return this.renderAdgroupWithCampaignLevelBudget();
            }
            return this.renderEmpty();
        }

        // BU/BUCC con 0 campaigns con budget → celda informativa
        if (platformBudget.campaigns_total !== undefined && platformBudget.campaigns_with_budget === 0) {
            return this.renderEmpty();
        }

        const isAggregate = rowType === TYPE_BUSINESS_UNIT || rowType === TYPE_CAMPAIGNS_CONFIGURATION;
        const currency = isAggregate
            ? (platformBudget.currencies && platformBudget.currencies[0])
            : platformBudget.currency;

        const formattedValue = `${this.formatMoney(platformBudget.daily_equivalent, currency)}${t('dashboard.platform_budget.daily_suffix')}`;

        const showInfoIcon = (isAggregate && platformBudget.has_lifetime) ||
            (!isAggregate && platformBudget.has_lifetime) ||
            (platformBudget.currencies && platformBudget.currencies.length > 1);

        return (
            <td className="single-data platform-budget-cell">
                <span className="platform-budget-value">{formattedValue}</span>
                {showInfoIcon && (
                    <span className="info-icon-container ms-1">
                        <FaIcon iconName="info-circle"/>
                        {this.renderBreakdownTooltip()}
                    </span>
                )}
            </td>
        );
    }
}

export const PlatformBudgetCell = withTranslation()(PlatformBudgetCellClass);
